import { useRouter } from 'next/router';
import CategoriesTemplate from "@components/layouts/menu/templates/new-categories";
import { CategoryMenu } from '@framework/types';
import { ROUTES } from '@lib/routes';
import React from 'react';


interface CategoriesMenuProps {
  setActive?: any;
  active?: boolean;
}

const CategoriesMenu: React.FC<CategoriesMenuProps> = ({
  setActive,
  active = true
}) => {
  const router = useRouter();

  async function onClickCategoryItemHandler(item: CategoryMenu) {
    // @ts-ignore
    window.gtag('event', 'click_categories', {
      'event_category': item.name,
    });
    setActive?.(false);
    router.push(`${ROUTES.CATEGORIES}/${item.id}`);
  }

  return (
    <CategoriesTemplate onClickCategoryItemHandler={onClickCategoryItemHandler} activeLoadData={active} />
  );
};

export default CategoriesMenu;
